import { computed } from '@vue/composition-api'

export const useExport = () => {
  const isExportEnabled = computed(() => {
    return ['1', 'true', 'True'].includes(process.env.VUE_APP_ENABLE_EXPORT)
  })

  return {
    isExportEnabled
  }
}
